import React from 'react';
import * as Styles from './HeaderDesignSection.styles';
import useLocale from '@/hooks/useLocale';
import { useStudio } from '@/hooks/studio';
import { IconAdd, Tooltip } from 'gatorcomponents';
import { studioAnalytics } from '@/analytics/studio';
import { BLANK_DOCUMENT_ID } from '../../studio.enum';

const HeaderDesignSection = ({ isProPlan }) => {
  const { studio: studioLocale } = useLocale();
  const { openStudio } = useStudio();

  const handleButtonEditorClick = () => {
    studioAnalytics.openEditorClick();
    openStudio('new_document', BLANK_DOCUMENT_ID);
  };

  return (
    <Styles.Wrapper isProPlan={isProPlan}>
      <Styles.HeaderText>{studioLocale.headerDesignSection.headerText}</Styles.HeaderText>
      <Tooltip content={studioLocale.headerDesignSection.tooltip} preferredPosition="left" disableMobile="true">
        <Styles.ButtonEditor onClick={() => handleButtonEditorClick()}>
          <IconAdd color="highPure" />
        </Styles.ButtonEditor>
      </Tooltip>
    </Styles.Wrapper>
  );
};

export default HeaderDesignSection;
